const search = {
  namespaced: true,
  state: {
    searchWord: '',
    want: false,
    went: false,
    tags: '',
    months: ''
  },
  getters: {
    getSearchWord: (state) => state.searchWord,
    getWant: (state) => state.want,
    getWent: (state) => state.went,
    getTags: (state) => state.tags,
    getMonths: (state) => state.months
  },
  mutations: {
    setSearchWord (state, searchWord) {
      state.searchWord = searchWord
    },
    setWant (state, want) {
      state.want = want
    },
    setWent (state, went) {
      state.went = went
    },
    setMonths (state, months) {
      state.months = months
    }
  },
  actions: {
    setSearchWord ({ commit }, searchWord) {
      commit('setSearchWord', searchWord)
    },
    setWant ({ commit }, want) {
      commit('setWant', want)
    },
    setWent ({ commit }, went) {
      commit('setWent', went)
    },
    setMonths ({ commit }, months) {
      commit('setMonths', months)
    }
  }
}

export default search



// WEBPACK FOOTER //
// ./src/vuex/search.js